<span class='app-legacy-badge'>
  {{ 'COMMON.LEGACY' | translate }}
</span>
